import styled from "styled-components";

import colors from "../../../assets/css/colors";

export const SelectContainer = styled.div`
    display: flex;
    align-items: center;
    margin-bottom:38px;
`;

export const Select = styled.select`
    width:182px;
    height: 31px;
    background: ${colors.white};
    color: ${colors.tertiary};
    border-radius: 7px;
    border: 1px solid rgba(194, 194, 194, 0.2);
    font-size: 0.8em;
    font-weight: 300;
    line-height: 1.45;
    outline: none;
    padding: 0.4em 1em 0.4em;
    -webkit-transition: 0.18s ease-out;
    -moz-transition: 0.18s ease-out;
    -o-transition: 0.18s ease-out;
    transition: 0.18s ease-out;

    -webkit-box-shadow:  -4px 3px 19px -8px rgba(194, 194, 194, 0.726);
    -moz-box-shadow:  -4px 3px 19px -8px rgba(194, 194, 194, 0.726);
    box-shadow:  -4px 3px 19px -8px rgba(194, 194, 194, 0.726);

    &:hover {
        border: 1px solid rgba(255, 169, 89, 0.2);
        -webkit-box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
        -moz-box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
        box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
    }

    &:focus {
        color: var(--gray);
        border: 1px solid ${colors.secondaryDark};
        -webkit-box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
        -moz-box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
        box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
    }

    &:disabled {
        background-color: ${colors.grayLightest};
    }

    &::-webkit-input-placeholder {
        /* WebKit browsers */
        text-transform: none;
    }
    &:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        text-transform: none;
    }
    &::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        text-transform: none;
    }
    &:-ms-input-placeholder {
        /* Internet Explorer 10+ */
        text-transform: none;
    }
    &::placeholder {
        /* Recent browsers */
        text-transform: none;
    }
`;

export const SelectLabel = styled.label`
    font: normal normal normal 14px Circular Std Book;
    color: ${colors.tertiary};
    margin-right: 12px;
    margin-bottom: 0px;
    width: 126px;
`;

export const Th = styled.th`
    font: normal normal normal 14px Circular Std Book;
    font-weight: bold;
    color: ${colors.tertiary};
    text-align: center;
`;

export const Tr = styled.tr`
    height: 44px;
`;

export const Td = styled.td`
    min-width: 70px;
`;

export const AppName = styled.td`
    font: normal normal normal 14px Circular Std Book;
    color: ${colors.grayDark};
    padding-right: 15px;
`;

export const ButtonContainer = styled.div`
    width: 284px;
    margin-top: 47px;
    margin-bottom: 30px;
`;